/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectChangeOrderDetailsCommand } from '../../models/update-project-change-order-details-command';
import { UpdateProjectChangeOrderDetailsCommandResult } from '../../models/update-project-change-order-details-command-result';

export interface ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Params {
      body?: UpdateProjectChangeOrderDetailsCommand
}

export function apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>;
    })
  );
}

apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain.PATH = '/api/ProjectChangeOrder/UpdateProjectChangeOrderDetails';
